import React, { useState } from 'react';
import { Card } from 'semantic-ui-react';
import { useLocation, useNavigate } from 'react-router-dom';
import TokensTable from '../../components/TokensTable';
import TokenModal from './TokenModal';
import { useTranslation } from 'react-i18next';

const Token = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const editMatch = pathname.match(/^\/token\/edit\/(\d+)\/?$/);
  const id = editMatch ? editMatch[1] : undefined;
  const navigate = useNavigate();
  const [reloadKey, setReloadKey] = useState(0);
  const modalOpen = /^\/token\/add\/?$/.test(pathname) || id !== undefined;

  const closeModal = (saved) => {
    navigate('/token');
    if (saved) setReloadKey((k) => k + 1);
  };

  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>{t('token.title')}</Card.Header>
          <TokensTable reloadKey={reloadKey} />
        </Card.Content>
      </Card>
      <TokenModal open={modalOpen} tokenId={id} onClose={closeModal} />
    </div>
  );
};

export default Token;
